var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('remaining-tasks-list',{attrs:{"title":_vm.title,"tasks":_vm.tasks}})}
var staticRenderFns = []

export { render, staticRenderFns }